import Shape from './Shape';

export default class Dot extends Shape {
    public type = 1
    constructor(item: any, index: number) {
        super(item, index)
    }
}
